var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBookmark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 19,
    viewBox: "0 0 15 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.0625 0.3125H0.9375C0.574512 0.3125 0.28125 0.605762 0.28125 0.96875V18.0312C0.28125 18.3942 0.574512 18.6875 0.9375 18.6875H14.0625C14.4255 18.6875 14.7188 18.3942 14.7188 18.0312V0.96875C14.7188 0.605762 14.4255 0.3125 14.0625 0.3125ZM8.73047 1.78906H10.6992V6.09365L9.74561 5.39844L8.73047 6.12441V1.78906ZM13.2422 17.2109H1.75781V1.78906H7.5V7.87783C7.5 7.94551 7.52051 8.01318 7.56152 8.06855C7.58642 8.10375 7.61805 8.13366 7.65458 8.15655C7.69111 8.17944 7.73182 8.19486 7.77435 8.20192C7.81688 8.20898 7.86039 8.20753 7.90236 8.19766C7.94432 8.18779 7.98392 8.1697 8.01885 8.14443L9.7374 6.91602L11.4067 8.13418C11.4621 8.1752 11.5298 8.19775 11.5995 8.19775C11.78 8.19775 11.9276 8.0501 11.9276 7.86963V1.78906H13.2401V17.2109H13.2422Z",
    fill: "#727D9B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBookmark);
export default __webpack_public_path__ + "static/media/bookmark.95cf93076c367bc9c1e0130e4f1c29d2.svg";
export { ForwardRef as ReactComponent };